/**
 * The typed oRPC client and its TanStack Query utilities.
 * UI never imports the server — it imports this. CLAUDE.md "Architecture".
 */

import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import type { RouterClient } from '@orpc/server'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import type { Router } from '@/adapters/rpc/router'
import { testModeAvailable } from '@/lib/flags'
import { isTestMode } from '@/lib/test-mode'

const link = new RPCLink({
  url: `${window.location.origin}/rpc`,
  // Read on every request, so flipping the toggle takes effect immediately.
  // Never sent at all when the project hasn't turned Test mode on (D-009).
  headers: () => (testModeAvailable && isTestMode() ? { 'x-test-mode': 'on' } : {}),
})

export const client: RouterClient<Router> = createORPCClient(link)

/** `orpc.items.list.queryOptions()`, `orpc.items.create.mutationOptions()`, … */
export const orpc = createTanstackQueryUtils(client)
